import { jsxs, jsx } from 'react/jsx-runtime.js';
import cn from 'classnames';
import FocusLock from 'react-focus-lock';
import Popup from '@jetbrains/ring-ui/dist/popup/popup.js';
import { Directions } from '@jetbrains/ring-ui/dist/popup/popup.consts.js';
export { Directions } from '@jetbrains/ring-ui/dist/popup/popup.consts.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import typographyStyles from '../../Typography/Typography.module.css.js';
import { useSubscribeMenuItems } from '../useSubscribeMenuItems.js';
import styles from './SubmenuPopup.module.css.js';

function SubmenuPopup(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$directions = _ref.directions,
    directions = _ref$directions === void 0 ? [Directions.BOTTOM_CENTER] : _ref$directions,
    menu = _ref.menu,
    open = _ref.open,
    onClose = _ref.onClose;
  var subitems = useSubscribeMenuItems(menu);
  if (subitems.length === 0) {
    return null;
  }
  return jsxs("div", {
    className: cn(className, styles.container),
    children: [children, jsx(Popup, {
      className: styles.submenuPopup,
      directions: directions,
      hidden: !open,
      onEscPress: onClose,
      onOutsideClick: onClose,
      children: jsx(FocusLock, {
        returnFocus: true,
        children: jsx("ul", {
          className: styles.submenuItemList,
          children: subitems.map(function (item) {
            return jsx("li", {
              children: item.type === 'normal' ? jsx("button", {
                className: cn(typographyStyles.text, styles.submenuItem),
                onClick: item.click,
                disabled: item.enabled === false,
                children: item.label
              }) : item.type === 'link' ? jsx("a", {
                className: cn(typographyStyles.text, styles.submenuItem),
                href: item.link,
                children: item.label
              }) : null
            }, item.id || item.label);
          })
        })
      })
    })]
  });
}

export { SubmenuPopup };
